import { Injectable } from '@angular/core';
import { SessionStorageService } from 'ngx-webstorage';
import { BehaviorSubject } from 'rxjs';

interface ICache {
	[key: string]: any;
}
@Injectable({
	providedIn: 'root',
})
export class MsStoreService {
	constructor(private sessionStorageService: SessionStorageService) {}

	set(key: string, value: any): void {
		this.sessionStorageService.store(key, value);
	}

	get(key: string): any {
		return this.sessionStorageService.retrieve(key) ?? null;
	}

	clear(key: string) {
		this.sessionStorageService.clear();
	}
}
